import { GridLayout } from "@arelia-components/layout/GridLayout";
import { PublishingRoyaltiesStats, PublishingRoyaltyDetail } from "./models";
import RoyaltiesBreakdown from "./components/RoyaltiesBreakdown";
import RoyaltiesByPeriod from "./components/RoyaltiesByPeriod";
import TableSummary from "./components/TableSummary";
import { useNavigate } from "react-router-dom";

type Props = {
  data: PublishingRoyaltyDetail[] | undefined;
  stats: PublishingRoyaltiesStats | null;
  isLoading: boolean;
};

export default function PublishingRoyaltiesDetailsPresenter({ data, stats, isLoading }: Props) {
  const navigate = useNavigate();

  const goToDetails = (type: string) => {
    const queryParams = new URLSearchParams({ type }).toString();
    navigate(`/earnings/publishing-royalties/details?${queryParams}`);
  };

  return <GridLayout>
    <RoyaltiesBreakdown isLoading={isLoading} breakdown={stats?.byTypes ?? []} onItemClick={type => goToDetails(type)}/>
    <RoyaltiesByPeriod isLoading={isLoading} data={stats?.periods} />
    <TableSummary
      isLoading={isLoading}
      rows={stats?.byTypes}
      onRowClick={type => goToDetails(type)}
    />
  </GridLayout>;
}